import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  AfterViewInit,
  inject,
} from '@angular/core';

@Component({
  standalone: false,
  selector: 'gstar-confirmation-modal',
  templateUrl: './confirmation-modal.component.html',
  styleUrls: ['./confirmation-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConfirmationModalComponent implements AfterViewInit {
  private readonly cdr = inject(ChangeDetectorRef);

  @Input({ required: true }) title!: string;
  @Input({ required: true }) content!: string;
  @Input() modalId!: string;
  @Input() confirmationFn?: () => void;
  @Input() hidePrimaryButton = false;

  ngAfterViewInit(): void {
    // AppKit dynamic modal assigns inputs via instance[prop]; ensure OnPush runs once.
    this.cdr.markForCheck();
  }

  confirm(): void {
    this.confirmationFn?.();
  }
}
